import { render, staticRenderFns } from "./ImgDragSort.vue?vue&type=template&id=1885207b&scoped=true&"
import script from "./ImgDragSort.vue?vue&type=script&lang=js&"
export * from "./ImgDragSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885207b",
  null
  
)

export default component.exports